import AutoField from '@cibo/ui/src/components/Form/Uniforms/AutoField'
import { CashCropField } from './CashCropField'
import { CoverCropField } from './CoverCropField'
import { HarvestTypeField } from './HarvestTypeField'
import { YieldPerAcreField } from './YieldPerAcreField'

export function componentDetector(props: any, _uniforms?: any) {
  switch (props.widget) {
    case 'CoverCropField':
      return CoverCropField
    case 'CashCropField':
      return CashCropField
    case 'HarvestTypeField':
      return HarvestTypeField
    case 'YieldPerAcreField':
      return YieldPerAcreField
  }

  // let dynamic-uniforms choose default
  return AutoField.defaultComponentDetector(props)
}
